<template>
  <div class="deviceListManagement">

    <div class="content abcds" ref="scrollContainer">
      <div class="scroll-a" v-if="titelData.length>0">
        <div v-for="(it, i) in titelData"
             :key="i"
             class="custom-checkbox">
          <van-cell class="checkbox-content"
                    icon="/static/images/etv-folder.png">
            <div class="ellipsis">
              <span class="name">{{ truncatedName(it.name) }} </span>
              <span style="float: right;">
              <van-icon name="/static/images/terminal/del.png" v-if="it.id !== '1'" style="margin-right: 10px" @click="deleTer(it.id,i)" ></van-icon>
              <van-icon name="/static/images/terminal/exit.png" v-if="it.id !== '1'" @click="exit(it.name,it.id)" ></van-icon>
            </span>
            </div>
          </van-cell>
        </div>
      </div>
      <van-empty
          v-else
          class="custom-image"
          image="/static/images/terminal/empty-img.png"
          :description="$t('append_field.data_empty')"
      />
    </div>
    <div class="btns">
        <van-button color="#006EFF" size="small" @click="dialogShow=true">{{$t('append_field.create')}}</van-button>
    </div>
    <van-dialog v-model="dialogShow"
                :title="title"
                show-cancel-button
                @confirm="onsubmit"
                class="edit-dialog"
                :beforeClose="vBeforeClose"
                @cancel="inputDialogClose">
      <van-row >
        <van-field
            v-model="groupName"
            :label="$t('append_field.name')"
            :placeholder="$t('append_field.ps_push_name')"
            clearable
            style="margin: 40px 0">
        </van-field>
      </van-row>
    </van-dialog>
    <van-overlay :show="overlayShow">
      <div class="wrapper">
            <span class="close" @click="overlayShow = false">
              <van-icon name="cross"/>
            </span>
        <van-loading size="40px">{{$t('append_field.call_device_please_wait')}}</van-loading>
      </div>
    </van-overlay>
    <van-overlay :show="showLoading">
      <div style="height: 100%;display: flex;justify-content: center;align-items: center">
        <van-loading  size="40px" vertical >{{ msg }}...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import qs from 'qs'
import {Dialog, Toast} from 'vant'
import {vBeforeClose} from "@/utils/tool";
import {trim} from "lodash/string";

export default {
  name: 'Terminal',

  inject: ['reload'],
  data() {
    return {
      data: [],
      titelData: [],
      loading: false,
      index: 0,
      dialogShow: false,
      groupName: '',
      show: false,
      overlayShow: false,
      showLoading: true,
      msg:this.$t('append_field.loadingb'),
      title:this.$t('append_field.create_terminal_group'),
    }
  },

  mounted() {

    this.showLoading=true
    this.getData()

  },
  methods: {
    vBeforeClose,


    handleResize() {
      // 获取底部导航栏元素
      const tabbar = document.querySelector('.van-tabbar')
      tabbar.style.display = 'none'
    },
    truncatedName(fullName) {
      // 截断名称并确保括号内容完整显示
      const namePart = fullName.split(' (')[0];
      const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : '';

      // 判断是否为英文名（假设英文名不包含中文字符）
      const isEnglish = /^[A-Za-z\s]+$/.test(namePart);

      // 根据是否为英文名选择不同的截断长度
      const maxLength = isEnglish ? 16: 6;

      if (namePart.length <= maxLength) {
        return fullName;
      } else {
        return `${namePart.substring(0, maxLength)}...${infoPart}`;
      }
    },

    getData() {
      this.msg = this.$t('append_field.loadingb')
      this.$ajax.post('/etv/selectDeviceTree.json').then(res => {
        this.titelData = []
        this.dataList = []
        if (res.data.code === 0) {

          this.titelData = res.data.data[0].children

          this.$nextTick(() => {
            this.showLoading = false
          })
        }
      })
    },


    deleTer(id,index) {
      Dialog.confirm({
        title: this.$t('append_field.delete_group'),
        message: this.$t('append_field.confirmDeleteGroup'),
      }).then(() => {
        this.$ajax.post('/etv//deleteGroupById.json', qs.stringify({
          id: id,
        })).then(res => {
          if (res.data.code === 0) {
            Toast(res.data.msg)
            this.titelData.splice(index, 1)
          }else {
            Toast(res.data.msg)
          }
        })
      }).catch(() => {

      })
    },

    exit(name,id) {
      this.dialogShow=true
      //去除两端的空白字符，提取分组名称
      this.groupName=trim(name.substring(0,name.indexOf('(')))
      this.id=id
      this.title=this.$t('append_field.exit_group_name')
    },

    onsubmit() {
      if(this.title===this.$t('append_field.create_terminal_group')){
        this.$ajax.post('/etv/insertGroup.json', qs.stringify({
          groupName: this.groupName,
          groupParentId: -1,
          groupDescp: '',
        })).then(res => {
          if (res.data.code === 0) {
            this.reload()
          } else {
            Toast(res.data.msg)
          }
        })
      }else {
        this.$ajax.post('/etv/updateClientNameOrGroupName.json', qs.stringify({
          name: this.groupName,
          id: this.id,
          type: "group"
        })).then(res => {
          if (res.data.code === 0) {
            this.reload()
          } else {
            Toast(res.data.msg)
          }
        })
      }

    },


    close() {
      this.show = false
      this.inputDialogClose()
    },


    inputDialogClose() {

      this.dialogShow = false
      this.show = false
      this.groupName = ''
    },
    back() {
      this.$router.back()
    }
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.deviceListManagement{

  height: 100% !important;
  overflow:hidden;

  .van-field{
    .van-field__label{
      width: 60px;
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    /*height: calc(100% - 70px);*/
    position: relative;

    .close {
      top: 10px;
      right: 10px;
      position: absolute;

      i {
        color: white;
      }
    }
  }

  .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
  }
  .btn-list{
    display: flex;
    overflow-x: auto; /* 水平滚动 */
    align-items: center;
    justify-content: flex-start;
    gap: 10px; /* 按钮之间的间隔 */
    height: 60px;
    border-bottom: 1px solid #707070;
    .terminal-btn{
      background-color: white;
      color: black;
      border: 1px solid #ddd; /* 可选：添加边框以便更清晰地看到按钮 */
    }
    .van-button__text{
      display: block;
      max-width: 100%;
      white-space: nowrap; /* 确保文本在一行显示 */
      overflow: hidden; /* 超出容器部分隐藏 */
      text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    }
    .selected {
      background-color: #006EFF ;
      color: white;
    }
  }
  .content {
    height: calc(100% - 60px );
    overflow-y: auto; /* 水平滚动 */

    .van-cell {
      padding: 10px 10px 0 10px;
      line-height: 30px;
      font-size: 16px;

    }

    .checkbox-content {
      display: flex;
      align-items: center;
      .ellipsis {
        width: 100%; /* 根据需要调整宽度 */
        display: flex;
        justify-content: space-between; /* 水平分布子元素 */
        align-items: center; /* 垂直居中对齐子元素 */
        .name{
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

        }
        .van-icon__image{
          width: 40px;
          height: 40px;
        }
      }
      .van-cell__left-icon{
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .van-icon__image{
        width: 26px;
        height: 26px;
      }
    }

    .van-collapse-item__title--expanded {
      background: $uni-color-primary;
      color: #ffffff;
    }

    .van-collapse-item__content {
      padding: 0;
    }

    .item-child {
      list-style: none;
      padding: 0 16px;

      li {
        padding: 10px 0;
        line-height: 30px;
        position: relative;
        display: flex;
        justify-content: space-between;
        font-size: 16px;

        button {
          line-height: 22px;
        }

        img {
          height: 24px;
          margin-right: 10px;
        }

        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: 1px solid $uni-border-bottom-color;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }

      li:nth-last-child(1) {
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: none;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }

    }


  }

  .btns {
    display: flex;
    height: 40px;
    justify-content: center;
    align-items: center;
    padding: 10px 15px;

  }

  .a {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .popup-title {
    height: 30px;
    line-height: 30px;
    padding-left: 15px;
  }

  .popup-btns {
    margin-top: 15px;
    padding: 0 15px;
  }

  .button-btns {
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .van-button--mini {
    font-size:  16px;
    height: 30px;
    box-sizing: border-box;
  }

  .van-cell__right-icon {
    color: white;
    line-height: 30px !important;
  }

  .van-cell__left-icon, .van-cell__right-icon {
    height: 30px;
    font-size: 16px !important;
    line-height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
  }
  .edit-dialog{
    .van-field__body{
      border-bottom: black 1px solid;
    }
    .van-field__label{
      width: 100%;
    }
    .van-cell{
      display: flex;
      flex-direction: column;
    }

  }
}
</style>
